import { TOGGLE_SIDEBAR } from './layoutConstants';

export function toggleSidebar() {
  return {
    type: TOGGLE_SIDEBAR
  };
}
